function closePage() {
  let anchor = document.querySelector('.header .close-page');

  if(anchor == null) {
    return;
  }

  anchor.addEventListener('click', event => {
    event.preventDefault();

    let last = document.referrer;

    if(last === null || last.indexOf('storefirst') === -1) {
      window.location = '/';
    } else {
      history.back();
    }
  });


}

export default closePage;
